// Single source of truth for the tag denylists shared by every model tag input
// (NewModelUploader, the legacy ModelPublisher, and the BatchDraftEditor).
//
// - restrictedTags:         reserved tags; adding one flashes an error and drops it.
// - prohibitedSoftwareTags: software/format names that now have dedicated
//   /3d-models/{slug} pages; adding one flashes an error and drops it. Mirrors the
//   server-side Item::PROHIBITED_SOFTWARE_TAGS (keep the two in sync). Includes
//   parameterized aliases (e.g. fusion-360, unity-3d) for the human-typed product names.
// - ignoredTags:            file-extension tokens; silently dropped, no error.

const restrictedTags = ['new', 'top-selling', 'trending']

const prohibitedSoftwareTags = [
  '3ds-max',
  'autocad',
  'cinema-4d',
  'fbx',
  'fusion360',
  'fusion-360',
  'glb',
  'gltf',
  'maya',
  'obj',
  'rhino',
  'sketchup',
  'solidworks',
  'stl',
  'unity',
  'unity-3d',
  'unreal-engine',
  'zbrush',
  'blender',
]

const ignoredTags = [
  'swastika',
  'rfa',
  '3ds',
  'dwg',
  'fbx',
  'c4d',
  'dxf',
  'lwo',
  'lw',
  'lws',
  'ma',
  'mb',
  'obj',
  '3dm',
  'skp',
  'hrc',
  'xsi',
  'max',
  'blend',
  'br5',
  'obp',
  'dae',
  'X',
  'ige',
  'igs',
  'iges',
  'iam',
  'lxo',
  'mxs',
  'flt',
  'pz3',
  'pp2',
  'rib',
  'slc',
  'sl',
  'slo',
  'rvt',
  'w3d',
  'sia',
  'stl',
  'wrl',
  'wrz',
  'vue',
  'ztl',
  'sldprt',
  'sldasm',
  'slddrw',
  'jas',
]

export { restrictedTags, prohibitedSoftwareTags, ignoredTags }
